import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, ShoppingCart } from 'lucide-react';

export const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-[#0F0720] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="glass-card p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center mx-auto mb-6">
            <ShoppingCart className="w-8 h-8 text-purple-400" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">Checkout Cancelled</h1>
          <p className="text-purple-300 mb-6">
            No worries! Your cart is still waiting for you. Ready to complete your order?
          </p>
          
          <div className="space-y-3">
            <Link to="/#products">
              <Button className="btn-primary w-full" data-testid="continue-shopping-btn">
                <ShoppingCart className="w-4 h-4 mr-2" />
                Continue Shopping
              </Button>
            </Link>
            
            <Link to="/">
              <Button className="btn-secondary w-full" data-testid="back-home-cancel-btn">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
